/**
 * @generated SignedSource<<cbd8587f4900663ef2e01c57a38ae862>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapSidebar_map",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapSidebarTitle_map"
    }
  ],
  "type": "ResourceTreeLeaf",
  "abstractKey": "__isResourceTreeLeaf"
};

node.hash = "1e439aca3f9af165e80af87f814f7994";

module.exports = node;
